// @flow @jsx h
import { h } from 'preact'
import { PureComponent } from '../../lib/pureComponent'
import type { Quiz, UserAnswersProps } from '../types'
import { Question } from './Question'

type Props = {
  quizData: Quiz,
  userAnswers: UserAnswersProps,
  onAnswerClick: () => void
}

export class Questions extends PureComponent<Props, {}> {
  render() {
    const { quizData, userAnswers } = this.props
    const { questions } = quizData
    return (
      <ul>
        {questions.map((question, index) => (
          <Question
            key={`${question.questionTitle}/${index}`}
            onAnswerClick={this.props.onAnswerClick}
            question={question}
            userAnswers={userAnswers}
            totalQuestions={questions.length}
          />
        ))}
      </ul>
    )
  }
}



// WEBPACK FOOTER //
// ./src/v1/components/Questions.js